<script>
const generate_rid = function (){
  let buffer = new ArrayBuffer(16)
  let intView = new Uint32Array(buffer)
  intView[0] = Math.random() * 1000000000000000
  intView[1] = Math.random() * 1000000000000000
  intView[2] = Math.random() * 1000000000000000
  intView[3] = Math.random() * 1000000000000000
  let binStr = String.fromCharCode.apply(null, new Uint8Array(buffer))
  let base64T = btoa(binStr)
  return base64T
}
const changeList = function(list){
  let arr = []
  if(!list.length) {return '{}'}                                                                   
  list.forEach(item => {
    let {exchange, underlying} = item
    arr.push(`{"market":"${exchange}","code":"${underlying}"}`)
  })
  return arr
}
const changeLists = function(list){
  let arr = []
  if(!list.length) {return '{}'}
  list.forEach(item => {
    let {exchange, instrument} = item
    arr.push(`{"market":"${exchange}","code":"${instrument}"}`)
  })
  return arr
}

const documentTypeOptions = [
  {value: '0', label: '中国居民身份证 '},
  {value: '1', label: '港澳居民来往内地通行证'},
  {value: '2', label: '台湾居民来往内地通行证'},
  {value: '3', label: '护照'},
  {value: '4', label: '公司邮箱(唯一)'},
]

const optionType = {      //期权交易数据type类型
  request: {
    requestMarket: 'REQUEST_UNDERLYING_QUOTE_INFO',      //初始化行情
    requestCodeInfo: 'REQUEST_UNDERLYING_CODE_INFO',      //代码表
  },
  push: {
    pushMarket: 'MT_REQUEST_UNDERLYING_QUOTE_SUBSCRIBE',
  },
  cancel: {
    cancelMarket: 'MT_REQUEST_UNDERLYING_QUOTE_CANCEL_SUBSCRIBE',
  },

  response: {         //响应
    initMarket: 'PUSH_UNDERLYING_QUOTE_INFO',       //初始化行情
    initCodeInfo: 'PUSH_UNDERLYING_CODE_INFO',        //初始化代码表
    pushType: 'PUSH_UNDERLYING_QUOTE',           //推送
  }
}

const forwordMessageType = {      //远期交易数据订阅type类型
  // 初始化请求数据
  request: {
    requestOrder: 'REQUEST_OTC_FORWARD_ORDER_INIT_DATA',
    requestTrade: 'REQUEST_OTC_FORWARD_TRADE_INIT_DATA',
    requestContract: 'REQUEST_OTC_FORWARD_CONTRACT_INIT_DATA',
    requestSettle: 'REQUEST_OTC_SETTLE_FORWARD_DAILY_PROFIT',     //盘前持仓
  },
  // 订阅数据
  push: {
    pushOrder: 'MT_REQUEST_OTC_FORWARD_ORDER_SUBSCRIBE',
    pushTrade: 'MT_REQUEST_OTC_FORWARD_TRADE_SUBSCRIBE',
    pushContract: 'MT_REQUEST_OTC_FORWARD_CONTRACT_SUBSCRIBE',
  },
  cancel: {
    cancelPushOrder: 'MT_REQUEST_OTC_FORWARD_ORDER_CANCEL_SUBSCRIBE',
    cancelPushTrade: 'MT_REQUEST_OTC_FORWARD_TRADE_CANCEL_SUBSCRIBE',
    cancelPushContract: 'MT_REQUEST_OTC_FORWARD_CONTRACT_CANCEL_SUBSCRIBE',
  },
}

const diffMessageType = {       //价差
  request: {
    requestConfig: ' REQUEST_ARBITRAGE_QUOTE_CONFIG_INIT_DATA',
  },
  push: {
    pushQuote: 'MT_REQUEST_ARBITRAGE_QUOTE_SBUSCRIBE',
  },
  cancel: {
    cancelQuote: 'MT_REQUEST_ARBITRAGE_QUOTE_CANCEL_SBUSCRIBE'
  }
}

const collectPositionObject = {     //汇总持仓的数据结构
  exchange: '',
  underlying: '',
  subAccountNo: '',
  subAccountName: '',
  buyContractVolume: 0,
  buyTodayOpenVolume: 0,
  buyTodayCloseVolume: 0,
  buyAveragePriceValue: 0,
  sellContractVolume: 0,
  netValue: 0,
  sellTodayOpenVolume: 0,
  sellTodayCloseVolume: 0,
  sellAveragePriceValue: 0,
  floatValue: 0,
  floatFValue: 0,
  closeOutLossZValue: 0,
  closeOutLossValue: 0,
  buyOriginalPriceContractValue: 0,
  sellOriginalPriceContractValue: 0,
  buyContractValue: 0,
  sellContractValue: 0,
  futuresMultiple: 0,

  buyHistoryDayRemainCloseVolume: 0,
  sellHistoryDayRemainCloseVolume: 0,
  buyTodayDayRemainCloseVolume: 0,
  sellTodayDayRemainCloseVolume: 0,
}
  export default {
    generate_rid,
    changeList,
    changeLists,
    documentTypeOptions,
    collectPositionObject,
    forwordMessageType,
    diffMessageType,
    optionType,
  }
</script>
